import _ from "lodash";
import * as ActionType from "./actionType";
import { registerApi, loginApi, getAuthByTokenApi } from "../services/auth";

const setLogin = (dispatch, data) => {
  dispatch({
    type: ActionType.RECEIVE_AUTH,
    data
  });
  dispatch({
    type: ActionType.IS_LOGIN,
    isLogin: true
  });
};

const registerAction = data => {
  return async dispatch => {
    const registerResult = await registerApi(data);
    const error = _.get(registerResult, "status") === "error";
    if (error) return registerResult;
    const { email, password } = data;
    return loginApi(email, password).then(tokenResult => {
      const tokenData = _.get(tokenResult, "data");
      if (!tokenData) return tokenResult;
      const { token } = tokenData;
      localStorage.setItem("token", token);
      return getAuthByTokenApi(token).then(userResult => {
        const userData = _.get(userResult, "data");
        if (!userData) return userResult;
        setLogin(dispatch, userData);
        return userData;
      });
    });
  };
};

const loginAction = (uid, password) => {
  return dispatch => {
    return loginApi(uid, password).then(tokenResult => {
      const tokenData = _.get(tokenResult, "data");
      if (!tokenData) return tokenResult;
      const { token } = tokenData;
      localStorage.setItem("token", token);
      return getAuthByTokenApi(token).then(userResult => {
        const userData = _.get(userResult, "data");
        if (!userData) return userResult;
        setLogin(dispatch, userData);
        return userData;
      });
    });
  };
};

const logoutAction = () => {
  return dispatch => {
    localStorage.removeItem("token");
    dispatch({
      type: ActionType.IS_LOGIN,
      isLogin: false
    });
  };
};

const getAuthByTokenAction = token => {
  return dispatch => {
    return getAuthByTokenApi(token).then(userResult => {
      const userData = _.get(userResult, "data");
      if (!userData) return userResult;
      setLogin(dispatch, userData);
      return userData;
    });
  };
};

export { registerAction, loginAction, logoutAction, getAuthByTokenAction };



// WEBPACK FOOTER //
// ./src/actions/auth.js